import AnswerCheck from "./AnswerCheck";
import BackgroundImage from "./BackgroundImage";
import CategoryButtonsList from "./CategoryButtonsList";
import CategoryButton from "./CategoryButtonsList/categoryButton";
import Counter from "./Counter";
import Header from "./Header";
import Heading from "./Heading";
import Navigation from "./Navigation";
import NextButton from "./NextButton";
import QuizDragAndDrop from "./QuizDragAndDrop";
import DndElement from "./QuizDragAndDrop/dndElement";
import QuizPutInOrder from "./QuizPutInOrder";
import QuizSelect from "./QuizSelect";
import Logo from "./Logo";
import ErrorBoundary from "./ErrorBoundary";
import Switch from "./Switch";

const components = {
  Switch,
  ErrorBoundary,
  AnswerCheck,
  BackgroundImage,
  CategoryButtonsList,
  CategoryButton,
  Counter,
  Header,
  Heading,
  Logo,
  Navigation,
  NextButton,
  QuizDragAndDrop,
  DndElement,
  QuizPutInOrder,
  QuizSelect,
};

export default components;
